/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerInvestmentSettings} from '../api'

 export const useQueryGetCustomerInvestmentSettings = createReactQueryHook('getCustomerInvestmentSettings', getCustomerInvestmentSettings)
